import { tns } from 'tiny-slider'
import { registerComponent } from '../components-front';

registerComponent('column-carousel', _ => {
    let slider;
    document.querySelectorAll('.column-carousel').forEach(carousel => {
        const cols = carousel.dataset.cols || 2
        slider = tns({
            container: carousel,
            items: 1,
            slideBy: 1,
            gutter: 50,
            controls: false,
            navPosition: 'bottom',
            arrowKeys: true,
            lazyload: true,
            // responsive: {
            //     992: {
            //         items: cols,
            //     },
            // },
        })
    })

    // Nav
    const prevButton = document.querySelector('#prev-slide');
    const nextButton = document.querySelector('#next-slide');

    if (prevButton && nextButton) {
        [ prevButton, nextButton ].forEach(button => {
            button.addEventListener('click', (ev) => {
                switch (ev.target.id) {
                    case "prev-slide":
                        slider.goTo('prev');
                        break;
                    case "next-slide":
                        slider.goTo('next');
                        break;
                }
            })
        });
    }

})
